import { Module } from '@nestjs/common';
import { EducationController } from './education.controller';
import { EducationsService } from './education.service';
import { EducationAdapter } from './dto/education.adapater';
import { Education } from './education.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { TypeOrmModule } from '@nestjs/typeorm';

@Module({
  imports: [
    TypeOrmModule.forFeature([Education])
  ],
  controllers: [EducationController],
  providers: [EducationsService, EducationAdapter, ApplicationExceptionHandler],
  exports: [EducationsService]
})
export class EducationModule {}
